export type IInitializeExternalSources = (
  externalSources: IDCA.IExternalSource[],
  fieldSuffix: string,
  formId: string
) => void;

export function initializeExternalSources(
  externalSources: IDCA.IExternalSource[],
  fieldSuffix: string,
  formId: string
) {
  $.each(externalSources, (_, externalSource) => {
    if (window.debug) {
      console.info(`Load external source, ${externalSource}`);
    }
    if (externalSource) {
      if (typeof (window.DexeroCoreApp as any).onExternalSearchButtonRender === 'function') {
        (window.DexeroCoreApp as any).onExternalSearchButtonRender(
          formId,
          externalSource,
          fieldSuffix
        );
      } else {
        const $inputs = $(`:input[name^="field_${externalSource.fieldId}${fieldSuffix}"]`);

        const searchBtn = `<button type="button" class="external-search-button btn btn-primary" data-original-title="${externalSource.name}" onclick="window.DexeroCoreApp.showExternalSourceSearchPopup('${formId}','${externalSource.fieldId}', '${externalSource.externalSourceId}', '${externalSource.name}', '${fieldSuffix}', event.currentTarget); return false;">${window.externalSourceSearchBtnContent}${externalSource.name}</button>`;

        const searchBtnWrapped = `<span class="input-group-btn">${searchBtn}</span>`;

        $inputs.each((i, input) => {
          const $input = $(input);
          const isLatitudeInput = $(input).hasClass('latitude');
          const $inputGroup = $input.parent('.input-group');
          const $inputGroupBtn = $inputGroup.find('.input-group-btn');

          const type = $input.attr('type');
          if (type !== 'hidden' && !isLatitudeInput) {
            if ($inputGroupBtn.length) {
              $inputGroupBtn.append($(searchBtn));
            } else {
              if (!$inputGroup.length) {
                $input.wrap('<div class="input-group"></div>');
              }
              $input.after($(searchBtnWrapped));
            }

            $(searchBtn).tooltip({ container: 'body' });
          }
        });
      }
    }
  });
}
